import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import { createPortal } from 'react-dom';
import { useEffect } from 'react';
const { wrapper, hidden, content, innerContent, innerTitle, closeIcon } =
  styles;

const Modal = ({
  children,
  open,
  onCancel,
  width,
  title,
  closable,
  backgroundColor,
  id,
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }

    if (!open) {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [onCancel, open]);

  return createPortal(
    <div className={`${wrapper} ${!open ? hidden : ''}`} id={id}>
      <div className={content} style={{ backgroundColor }}>
        {closable && (
          <i className={`icon fas fa-times ${closeIcon}`} onClick={onCancel} />
        )}
        {title && <div className={innerTitle}>{title}</div>}
        <div className={innerContent} style={{ width }}>
          {open ? children : null}
        </div>
      </div>
    </div>,
    document.body,
  );
};

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  closable: PropTypes.bool,
  backgroundColor: PropTypes.string,
  id: PropTypes.string,
};

Modal.defaultProps = {
  onCancel: () => {},
  onSuccess: () => {},
  width: '100%',
  title: undefined,
  closable: false,
  backgroundColor: '#ffffff',
  id: undefined,
};

export default Modal;
